import { Component } from '@angular/core';

@Component({
  selector: 'lib-input-container',
  templateUrl: './input-container.component.html',
  styleUrl: './input-container.component.scss',
})
export class InputContainerComponent {}
